<div *ngIf="open">
  <div class="modal-overlay">
    <div class="modal">
      <div *ngIf="isCloseable" (click)="closeModal()" class="close-btn">
        <svg-icon src="/assets/icons/close.svg"></svg-icon>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
